// extracted by mini-css-extract-plugin
export default {"queryField":"styles_query-field__Dierq","focus":"styles_focus__ZMx04"};